import { useScrollData } from 'scroll-data-hook';
import React from 'react';
export function useScroll() {
  const { position, direction } = useScrollData();
  const showHeader = React.useRef(true);
  const isScrolledDown = position.y > 80;
  if (direction.y === 'up') showHeader.current = true;
  if (direction.y === 'down' && isScrolledDown) {
    showHeader.current = false;
  }
  return {
    showHeader: showHeader.current,
    isScrolledDown,
  };
}
